/*
 * @Author: EdwardYoung
 * @Date: 2017-08-02 10:49:24
 * @Last Modified by: EdwardYoung
 * @Last Modified time: 2017-09-18 19:43:12
 */

/**
 * 初始化axios，为aixos配置默认的baseURL及headers
 * @param {*} axios
 * @return {*} aixios
 */
function axiosInit (axios) {
  let protocol = getProtocol()
  let axiosConfig = getConfig()
  let port = axiosConfig.http
  if (protocol === 'https:') {
    port = axiosConfig.https
  }
  axios.defaults.baseURL = `${protocol}//${axiosConfig.api}:${port}`
  axios.defaults.headers = {
    'x-yhsd-shopkey': axiosConfig.shop_key
  }
  return axios
}

/**
 * 查找插入的app.js, 分析出axios的配置信息
 */
function getConfig () {
  let scriptArray = Array
    .prototype
    .slice
    .call(document.querySelectorAll('script'), 0)
  let configArray = scriptArray.filter((item) => {
    if (item.src.indexOf('plugin_name=kanjia') !== -1) {
      return item
    }
  })
  const configOptionArray = configArray[0].src.split('?')
  const configSearch = configOptionArray[1]
  const configAxiosConfigArray = decodeURIComponent(configSearch).split('&')
  let axiosConfig = {}
  for (const item of configAxiosConfigArray) {
    let configArray = item.split('=')
    const configName = configArray[0]
    const configValue = configArray[1]
    axiosConfig[configName] = configValue
  }
  return axiosConfig
}

function getProtocol () {
  return window.location.protocol
}

export {axiosInit}



// WEBPACK FOOTER //
// ./src/api/axiosInit.js